module.exports = __webpack_public_path__ + "img/abc_screenshot.125a5262.jpg";